import AbstractComponent from "./abstract-component";

const createTemplate = () => {
  return (
    `<section class="modal">
      <div class="modal__overlay"></div>
      <div class="modal__wrap authorization__modalWrap">
        <button class="modal__closeButton" type="button" title="Закрыть">
          <svg aria-hidden="true" width="16" height="16">
            <use class="" href="sienge/img/sprite.svg#close"></use>
          </svg>
        </button>

        <p class="modal__text">
          Продолжая использовать наш сайт, вы даете согласие на обработку файлов cookie:<br>
          – пользовательских данных, содержащих сведения о местоположении;<br>
          – тип, язык и версию ОС;<br>
          – тип, язык и версию браузера;<br>
          – сайт или рекламный сервис, с которого пришел пользователь; <br>
          – тип, язык и разрешение экрана устройства, с которого пользователь обращается к сайту;<br>
          – ip-адрес, с которого пользователь обращается к сайту;<br>
          – сведения о взаимодействии пользователя с web-интерфейсом и службами сайта;<br>
          
          в целях аутентификации пользователя на сайте, проведения ретаргетинга, статистических исследований и обзоров. 
        </p>
          
        <p class="modal__text">
          Если вы не хотите, чтобы ваши данные обрабатывались, покиньте сайт.
        </p>

        
        </div>
        </section>`
  );
};

        // <h2 class="modal__title">Сообщить об ошибке</h2>

// <textarea rows="8" placeholder="Введите текст ошибки..." spellcheck></textarea>
// <div class="modal__buttonWrap" data-mode="button">
//   <button class="modal__button button-primary js--send" type="button">Отправить</button>
//   <div class="modal__progress">
//     <img src="/sienge/img/load_bar.gif" alt="">
//   </div>
// </div>

export default class CookieModalComponent extends AbstractComponent {
  constructor(className = ``) {
    super();

    this._className = className;

    // this._focusTextarea();
  }

  getTemplate() {
    return createTemplate(this._className);
  }

  setShowClass() {
    this.getElement().classList.add(`modal--show`);
  }

  setCloseButtonClickHandler(handler) {
    this.getElement().querySelector(`.modal__closeButton`)
    .addEventListener(`click`, handler);
  }

  setOverlayClickHandler(handler) {
    this.getElement().querySelector(`.modal__overlay`)
    .addEventListener(`click`, handler);
  }

  setSendButtonClickHandler(handler) {
    this.getElement().querySelector(`.js--send`)
    .addEventListener(`click`, () => {
      this.getElement().querySelector(`.modal__buttonWrap`).dataset.mode = `progress`;

      const message = this.getElement().querySelector(`textarea`).value;
      handler(message, () => {
        this.getElement().querySelector(`.modal__buttonWrap`).dataset.mode = `button`;
      });
    });
  }

  _focusTextarea() {
    const textarea = this.getElement().querySelector(`textarea`);
    if (textarea) {
      textarea.focus();
    }
  }
}
